import { ConfigPublishState, RiskConfig } from '@Types/riskConfig.types';

export interface ComponentAvailability {
	section: 'lof' | 'cof';
	categoryName: string;
	componentName: string;
	kind: string;
	weight: number;
	available: boolean;
	reason?: string;
}

export interface ApplyRiskTemplateRequest {
	name: string;
	systemType: string;
	assetType: string;
	publishState: ConfigPublishState;
	assetFilterId?: string;
	inspectionStandard?: string;
	templateId: string;
}

export interface ApplyRiskTemplateResponse {
	config: RiskConfig;
	// Optional: the I360A-2704 backend is still in flight, so a partial or
	// older response can omit these — callers must default them (see
	// applyRiskTemplateSaga) rather than assume they're always present.
	availability?: ComponentAvailability[];
	unrecognisedValues?: { componentName: string; values: string[] }[];
}

export type TemplateApplyStatus = 'idle' | 'applying' | 'applied' | 'error';

export interface TemplateApplyState {
	status: TemplateApplyStatus;
	availability: ComponentAvailability[];
	unrecognisedValues: { componentName: string; values: string[] }[];
	templateLabel?: string;
}

export const templateApplyInitialState: TemplateApplyState = {
	status: 'idle',
	availability: [],
	unrecognisedValues: [],
	templateLabel: undefined,
};
